import React from 'react';
import { Button } from '@mantine/core';
import { IconCircleX } from '@tabler/icons-react';

const SubtleButton = ({ buttonColor, text, ...props }: any) => {
  return (
    <>
      <Button variant={'subtle'} style={{ borderBottom: `2px solid ${buttonColor}` }} {...props}>
        {text}
      </Button>
    </>
  );
}

export default SubtleButton;